<template>
  <nav class="navbar" :class="{ 'is-scrolled': scrolled, 'is-transparent': isHomePage && !scrolled && !menuOpen }">
    <div class="nav-container">
      <!-- Logo放在导航菜单内，首页旁边 -->
      <div class="nav-left">
        <router-link to="/home" class="nav-logo">
          <img
            :src="isHomePage && !scrolled && !menuOpen
              ? require('@/assets/img/logo_white.png')
              : require('@/assets/img/logo_black.png')"
            alt="企文达"
            class="logo-img"
          />
        </router-link>

        <!-- 桌面导航 -->
        <ul class="nav-menu">
          <li
            v-for="(item, index) in navList"
            :key="index"
            class="nav-menu-item"
            :class="{ 'has-sub': item.children && item.children.length }"
          >
            <router-link :to="item.path" class="nav-link" active-class="is-active" @click.native="closeMenu">
              {{ item.name }}
              <i v-if="item.children && item.children.length" class="fas fa-angle-down sub-arrow"></i>
            </router-link>
            <!-- 二级下拉 -->
            <div v-if="item.children && item.children.length" class="sub-menu">
              <router-link
                v-for="(child, ci) in item.children"
                :key="ci"
                :to="child.path"
                class="sub-menu-link"
                @click.native="closeMenu"
              >
                {{ child.name }}
              </router-link>
            </div>
          </li>
        </ul>
      </div>

      <!-- 右侧操作区 -->
      <div class="nav-actions">
        <router-link to="/admin" class="nav-admin-btn" @click.native="closeMenu">
          <i class="fas fa-lock"></i>
          <span>管理后台</span>
        </router-link>
        <!-- 汉堡 -->
        <button
          class="nav-hamburger"
          :class="{ 'is-open': menuOpen }"
          @click="toggleMenu"
          aria-label="菜单"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <transition name="menu-slide">
      <div class="mobile-menu" v-show="menuOpen">
        <div class="mobile-menu-inner">
          <div class="mobile-logo">
            <img src="@/assets/img/logo_black.png" alt="企文达" class="mobile-logo-img" />
          </div>
          <div
            v-for="(item, index) in navList"
            :key="index"
            class="mobile-menu-group"
          >
            <router-link
              :to="item.path"
              class="mobile-menu-link"
              active-class="is-active"
              @click.native="closeMenu"
            >
              {{ item.name }}
            </router-link>
            <div v-if="item.children && item.children.length" class="mobile-sub">
              <router-link
                v-for="(child, ci) in item.children"
                :key="ci"
                :to="child.path"
                class="mobile-sub-link"
                @click.native="closeMenu"
              >
                {{ child.name }}
              </router-link>
            </div>
          </div>
          <router-link to="/admin" class="mobile-admin-btn" @click.native="closeMenu">
            <i class="fas fa-lock"></i> 管理后台
          </router-link>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      scrolled: false,
      menuOpen: false,
      navList: [
        { name: '首页', path: '/home',                children: [] },
        { name: '关于我们', path: '/companyintroduction', children: [] },
        { name: '服务类目', path: '/software',           children: [
          { name: '企业活动策划', path: '/software/activity' },
          { name: '企业成长赋能', path: '/software/empower' },
          { name: '企业影像服务', path: '/software/video' },
          { name: '企业数字展厅', path: '/software/exhibition' },
          { name: '集采供应链', path: '/software/procurement' },
          { name: '企业视觉阵地', path: '/software/visual' }
        ]},
        { name: '发展历程', path: '/newsinformation',    children: [] },
        { name: '人才培育', path: '/jobchance',          children: [] },
        { name: '联系我们', path: '/contactus',          children: [] }
      ]
    }
  },
  computed: {
    isHomePage() {
      return this.$route && this.$route.path === '/home'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 60
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>

<style scoped>
/* ── 基础 ── */
.navbar {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 1000;
  height: 70px;
  background: #fff;
  box-shadow: 0 2px 16px rgba(0,0,0,0.08);
  transition: background 0.35s ease, box-shadow 0.35s ease;
}

/* 首页未滚动时透明 */
.navbar.is-transparent {
  background: transparent;
  box-shadow: none;
}

/* 滚动后加深阴影 */
.navbar.is-scrolled {
  background: rgba(255,255,255,0.98);
  box-shadow: 0 4px 28px rgba(0,0,0,0.1);
  backdrop-filter: blur(8px);
}

.nav-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  position: relative;
}
.nav-left {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-left: -50px;
}

/* ── Logo ── */
.nav-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
}
.logo-img {
  height: 100px;
  width: auto;
  transition: opacity 0.2s;
}

/* ── 桌面菜单 ── */
.nav-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  gap: 2px;
  flex: 1;
  justify-content: center;
}

.nav-menu-item {
  position: relative;
}
.nav-menu-item.has-sub::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 20px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 13px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  border-radius: 6px;
  white-space: nowrap;
  transition: color 0.2s, background 0.2s;
  letter-spacing: 0.02em;
}

/* 透明导航时文字变白 */
.is-transparent .nav-link {
  color: rgba(255,255,255,0.9);
}
.is-transparent .nav-link:hover {
  color: #fff;
  background: rgba(255,255,255,0.12);
}

.nav-link:hover,
.nav-link.is-active {
  color: #007bff;
  background: rgba(0,123,255,0.07);
}
.is-transparent .nav-link.is-active {
  color: #fff;
  background: rgba(255,255,255,0.18);
}

.sub-arrow {
  font-size: 11px;
  transition: transform 0.25s;
}
.nav-menu-item:hover .sub-arrow {
  transform: rotate(180deg);
}

/* ── 二级下拉 ── */
.sub-menu {
  display: none;
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 180px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.13);
  padding: 8px 0;
  border: 1px solid rgba(0,0,0,0.05);
  z-index: 100;
}
/* 小三角 */
.sub-menu::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  width: 12px;
  height: 12px;
  background: #fff;
  border-left: 1px solid rgba(0,0,0,0.05);
  border-top: 1px solid rgba(0,0,0,0.05);
  transform: translateX(-50%) rotate(45deg);
}
.nav-menu-item:hover .sub-menu {
  display: block;
}
.sub-menu-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 24px;
  font-size: 14px;
  color: #444;
  text-decoration: none;
  text-align: center;
  transition: color 0.2s, background 0.2s;
  white-space: nowrap;
}
.sub-menu-link:hover {
  color: #007bff;
  background: rgba(0,123,255,0.05);
}
.sub-menu-icon {
  display: none;
}

/* ── 右侧操作区 ── */
.nav-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  position: absolute;
  right: 24px;
}

.nav-admin-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  background: linear-gradient(135deg, #007bff 0%, #0056d2 100%);
  color: #fff;
  border-radius: 22px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 4px 14px rgba(0,123,255,0.3);
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
}
.nav-admin-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0,123,255,0.4);
  color: #fff;
}

/* ── 汉堡 ── */
.nav-hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 36px;
  height: 36px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}
.nav-hamburger span {
  display: block;
  height: 2px;
  background: #333;
  border-radius: 2px;
  transition: all 0.28s ease;
}
.is-transparent .nav-hamburger span {
  background: #fff;
}
.nav-hamburger.is-open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
.nav-hamburger.is-open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
.nav-hamburger.is-open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

/* ── 移动端菜单 ── */
.mobile-menu {
  position: absolute;
  top: 70px;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 12px 32px rgba(0,0,0,0.12);
  border-top: 1px solid #f0f0f0;
  overflow: hidden;
}
.mobile-menu-inner {
  padding: 12px 0 16px;
}
.mobile-logo {
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
}
.mobile-logo-img {
  height: 60px;
  width: auto;
}
.mobile-menu-group {
  border-bottom: 1px solid #f5f5f5;
}
.mobile-menu-group:last-of-type {
  border-bottom: none;
}
.mobile-menu-link {
  display: block;
  padding: 13px 24px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  transition: color 0.2s, background 0.2s;
}
.mobile-menu-link:hover,
.mobile-menu-link.is-active {
  color: #007bff;
  background: rgba(0,123,255,0.04);
}
.mobile-sub {
  background: #fafafa;
}
.mobile-sub-link {
  display: block;
  padding: 10px 36px;
  font-size: 13px;
  color: #666;
  text-decoration: none;
  transition: color 0.2s;
}
.mobile-sub-link:hover {
  color: #007bff;
}
.mobile-admin-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 16px 4px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #007bff, #0056d2);
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  justify-content: center;
}

/* 动画 */
.menu-slide-enter-active,
.menu-slide-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  max-height: 600px;
}
.menu-slide-enter,
.menu-slide-leave-to {
  max-height: 0;
  opacity: 0;
}

/* ── 响应式 ── */
@media (max-width: 1024px) {
  .nav-menu { display: none; }
  .nav-hamburger { display: flex; }
  .nav-admin-btn span { display: none; }
  .nav-admin-btn { padding: 8px 12px; border-radius: 50%; }
}
@media (max-width: 480px) {
  .nav-admin-btn { display: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue